import React from 'react';
import PropTypes from 'prop-types';

import LocalizationConsumer from '../../../../l10n/localization-context';

const WebsiteTab = ({ onChange, url }) => (
  <div className="-wa-edit-controls__website-tab">
    <div className="-wa-edit-controls__property-label -wa-edit-controls__property-label-website-url">
      <LocalizationConsumer id="insert-link-dialog.website-tab.url" />
    </div>
    <div className="-wa-edit-controls__property-control">
      <input
        className="-wa-edit-controls__property-input -wa-edit-controls__property-website-input"
        name="url"
        value={url}
        onChange={e => onChange(e.target.value)}
        type="text"
        maxLength="1024"
      />
    </div>
    <div className="-wa-edit-controls__input-hint">
      <LocalizationConsumer id="insert-link-dialog.website-tab.url-hint" />
    </div>
  </div>
);

WebsiteTab.propTypes = {
  onChange: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired
};

export default WebsiteTab;
